import menuCodes from "@/utils/menu-codes";

export const mainMenuMerchProps = () => ({
  pushZones: {
    type: Array,
    required: false,
    default: () => []
  },
  level: {
    type: Number,
    required: false,
    default: 2
  }
})

export const useMainMenuMerch = (props) => {
  const pushZonesWithoutMarques = computed(() => {
    return props.pushZones.filter(zone => zone.code !== menuCodes.BRANDS)
  })

  return {
    pushZonesWithoutMarques
  }
}